import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TKeepingSession, TKeepingSessionResponse } from './post-keeping-session';

export type TPatchKeepingSession = Partial<TKeepingSession> & { id: string };

export async function patchKeepingSession(
  body: TPatchKeepingSession
): Promise<TKeepingSessionResponse> {
  return mediaManagerClient.patch(`/api/v1/time_keeping_sessions/${body.id}`, body);
}

type MutationFn = typeof patchKeepingSession;

type TUsePatchKeepingSessionParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchKeepingSession({ config = {} }: TUsePatchKeepingSessionParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchKeepingSession,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la sesión'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La sesión se ha actualizado correctamente'));
      queryClient.invalidateQueries({
        queryKey: ['time-keeping-sessions'],
        exact: false,
      });
    },
  });
}
